import {getArtistCookie, pageFilter} from "../data/page_data";
import axios from "axios";
import Navbar from "../components/Navbar";
import React from "react";
import Footer from "../components/Footer";
import Loading from "../components/loading";
import AccountNavTab from "../components/AccountNavTab";
import CssLoader from '../components/CssLoader';
import {navigate} from "@reach/router";
import * as ReactGA from "react-ga";

export default class AccountPage extends React.Component{

    constructor(props) {
        super(props);
        this.pageData = pageFilter(this.props.artist, '../');
        this.state = {}
        this.cookie = getArtistCookie(this.props.artist);
    }

    componentDidMount() {
        axios.get('/w/api/' + this.pageData.artist.id + '/account',{headers:{
          PortalAuth: this.cookie
        }})
            .then(response => {
                var respData = response.data;
                this.setState(state => ({data: respData}));
            }).catch(error =>{
          document.location.href = "join";
            });
        axios.get('/w/api/' + this.pageData.artist.id + '/myauction',{headers:{
          PortalAuth: this.cookie
        }})
            .then(response => {
                var respData = response.data;
                this.setState(state => ({myauction: respData}));
            });
        axios.get('/w/api/' + this.pageData.artist.id + '/likes',{headers:{
          PortalAuth: this.cookie
        }})
            .then(response => {
                var respData = response.data;
                this.setState(state => ({likes: respData}));
            });
        ReactGA.pageview(window.location.pathname + window.location.search);
    }

    render(){
        return <>
        <CssLoader css={this.pageData.artist.css}/>
            <Navbar data={this.pageData} title="ACCOUNT" />
            {!this.state.data ? <Loading/> :
                <AccountNavTab data={this.state.data}
                               myauction={this.state.myauction}
                               likes={this.state.likes} />
            }
            <Footer/>
            </>;
    }

}